<template>
  <div>
    <div class="writeBox writeBox1">
      <div class="writeItem">
        <label>订单成本消耗</label>
        <el-input class="input" v-model="editData.cost" placeholder="请输入订单成本消耗" @input="(val)=>{clearNoNum({value:val,valueName:'cost',mainName:'editData'})}" size='mini' :disabled="isEditable ? false : true"></el-input>
      </div>
      <div class="writeItem">
        <label>流量助推(使用返货)</label>
        <el-input class="input" v-model="editData.traffic_boost_refund" placeholder="请输入流量助推(使用返货)" @input="(val)=>{clearNoNum({value:val,valueName:'traffic_boost_refund',mainName:'editData'})}" size='mini' :disabled="isEditable ? false : true"></el-input>
      </div>
      <div class="writeItem">
        <label>流量助推(使用现金)</label>
        <el-input class="input" v-model="editData.traffic_boost_money" placeholder="请输入流量助推(使用现金)" @input="(val)=>{clearNoNum({value:val,valueName:'traffic_boost_money',mainName:'editData'})}" size='mini' :disabled="isEditable ? false : true"></el-input>
      </div>
      <div class="writeItem">
        <label>成本开票日期</label>
        <el-date-picker class="input" v-model="editData.cost_invoice_date" type="date" size="mini" value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="选择日期">
        </el-date-picker>
      </div>
      <div class="writeItem">
        <label>确认成本(含税)发票金额</label>
        <el-input class="input" v-model="editData.confirmed_cost_includes_tax" placeholder="请输入确认成本(含税)发票金额" @input="(val)=>{clearNoNum({value:val,valueName:'confirmed_cost_includes_tax',mainName:'editData'})}" size='mini'></el-input>
      </div>
      <div class="writeItem">
        <label>线下付款公司</label>
        <el-select class="input" v-model="editData.offline_subsidy_company" placeholder="请选择线下付款公司" size='mini' filterable :disabled="isEditable ? false : true">
          <el-option v-for="(item,index) in companyList" :key="index" :label="item.company_name" :value="item.company_name">
          </el-option>
        </el-select>
      </div>
      <div class="writeItem">
        <label>线下补款金额</label>
        <el-input class="input" v-model="editData.offline_subsidy_amount" placeholder="请输入线下补款金额" @input="(val)=>{clearNoNum({value:val,valueName:'offline_subsidy_amount',mainName:'editData'})}" size='mini' :disabled="isEditable ? false : true"></el-input>
      </div>
      <!-- <div class="writeItem">
                <label>线下补款开票日期</label>
                 <el-date-picker
                    class="input"
                    v-model="editData.offline_invoice_date"
                    type="date"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    placeholder="选择日期">
                </el-date-picker>
            </div>
            <div class="writeItem">
                <label>线下确认成本(含税)发票金额</label>
                <el-input class="input"  v-model="editData.offline_confirmed_cost_includes_tax" placeholder="请输入线下确认成本(含税)发票金额" @input="(val)=>{clearNoNum({value:val,valueName:'offline_confirmed_cost_includes_tax',mainName:'editData'})}" size='mini' ></el-input>
            </div> -->
      <div class="writeItem">
        <label>红字发票信息表日期</label>
        <el-date-picker class="input" v-model="editData.red_invoice_date" type="date" size="mini" value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="选择日期">
        </el-date-picker>
      </div>
      <div class="writeItem">
        <label>返点开票日期</label>
        <el-date-picker class="input" v-model="editData.refund_invoice_date" type="date" size="mini" value-format="yyyy-MM-dd" :picker-options="pickerOptions" placeholder="选择日期">
        </el-date-picker>
      </div>
      <div class="writeItem">
        <label>是否对公</label>
        <el-checkbox v-model="editData.if_public">是</el-checkbox>
      </div>
      <div class="writeItem">
        <label>备注</label>
        <el-input class="input" v-model="editData.note" placeholder="请输入备注" size='mini'></el-input>
      </div>
      <!-- 提交修改原因 -->
      <div class="writeBox" v-if="editData.status>2">
        <p class="title">修改原因</p>
        <div class="writeItem" style="width:90%">
          <el-input class="input" type="textarea" v-model.trim="op_reason" placeholder="请输入修改原因" size='mini'></el-input>
        </div>
      </div>
    </div>
    <!-- button  -->
    <div class="buttones">
      <button class="yes" @click="orderUpdate()">{{editData.status>2?'提交审核':'提交'}}</button>
      <button @click="orderCancelClick">取消</button>
    </div>
  </div>
</template>
<script>
export default {
  props: ['editDataTotal'],
  data () {
    // S 获取当前角色是否具备可编辑权限
    const isEditableRoleIds = [12]
    const currentRoleId = JSON.parse(this.$cookie.getCookie('userInfo') || '{}').role_id || 0
    const isEditable = isEditableRoleIds.includes(Number(currentRoleId))
    // E 获取当前角色是否具备可编辑权限

    return {
      editData: JSON.parse(JSON.stringify(this.editDataTotal)),
      pickerOptions: {
        // disabledDate(time) {
        //     return time.getTime() > Date.now();
        // },
      },
      companyList: [],
      op_reason: '',
      isEditable: isEditable,
    }
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    this.companyListEvent();//线下付款公司
  },
  methods: {
    clearNoNum ({ value, valueName, mainName }) {//判断只能输入纯数字或者小数点，及负整数
      var t = value.charAt(0);
      //先把非数字的都替换掉，除了数字和.
      value = value.replace(/[^\d.]/g, "");
      //必须保证第一个为数字而不是.
      value = value.replace(/^\./g, "");
      //保证只有出现一个.而没有多个.
      value = value.replace(/\.{2,}/g, ".");
      //保证.只出现一次，而不能出现两次以上
      value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      //如果第一位是负号，则允许添加   如果不允许添加负号 可以把这块注释掉
      if (t == '-') {
        value = '-' + value;
      }
      if (mainName) {
        this[mainName][valueName] = value
      } else {
        this[valueName] = value
      }
    },
    orderCancelClick () {
      this.$emit('cancelToast')
    },
    orderUpdate () {//编辑订单
      if (this.editData.status > 2 && this.op_reason == '') {
        this.$message({
          message: '请输入修改原因！',
          type: 'warning'
        })
        return
      }
      this.$loading(this.$loadingConfig)
      this.$axios.post(this.URL.BASEURL + this.URL.costUpdate, {
        id: this.editData.id,
        cost: this.editData.cost,
        traffic_boost_refund: this.editData.traffic_boost_refund,
        traffic_boost_money: this.editData.traffic_boost_money,
        cost_invoice_date: this.editData.cost_invoice_date,
        confirmed_cost_includes_tax: this.editData.confirmed_cost_includes_tax,
        offline_subsidy_company: this.editData.offline_subsidy_company,
        offline_subsidy_amount: this.editData.offline_subsidy_amount,
        // offline_invoice_date: this.editData.offline_invoice_date,
        // offline_confirmed_cost_includes_tax: this.editData.offline_confirmed_cost_includes_tax,
        red_invoice_date: this.editData.red_invoice_date,
        refund_invoice_date: this.editData.refund_invoice_date,
        note: this.editData.note,
        if_public: this.editData.if_public ? 1 : 0,
        op_reason: this.editData.status > 2 ? this.op_reason : '',
        verify_edit: this.editData.status > 2 ? 1 : 0

      }).then((res) => {
        var res = res.data;
        this.$loading(this.$loadingConfig).close()
        if (res && res.errno == 0) {
          var hint = '编辑成功！';
          if (this.editData.status > 2) {
            hint = '提交成功！'
          }
          this.$alert(hint, '成功', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            callback: action => {
              this.$emit('emit_refresh')
            }
          });
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close()
      })
    },
    companyListEvent () {//线下付款公司
      this.$axios.get(this.URL.BASEURL + this.URL.companyList, {
        params: {
          page: 1,
          page_size: 999,
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.companyList = res.rst.data;
          // 2023.12.05 编辑回显异常 不确定is_default字段的作用
          // this.companyList.forEach((item) => {
          //   if (item.is_default == 1) {
          //     this.editData.offline_subsidy_company = item.company_name
          //   }
          // });
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>
@import "./edit.scss";
</style>


// WEBPACK FOOTER //
// src/components/Order/medium/costRebateEdit.vue